export default {
  base: {
    maxWidth: ['100vw', 350, 605],
    mx: [20, 0, 0],
    backgroundColor: 'grey-0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 'sm',
    color: 'grey-60',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'grey-30',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    fontFamily: 'base',
    variant: 'spark.base.wrapper',
    header: {
      color: 'grey-100',
      mb: 'xxxs'
    }
  },
  arrow: {
    base: {
      visibility: 'hidden',
      height: 12,
      width: 12,
      bottom: -6,
      position: 'absolute',
      backgroundColor: 'inherit',
      before: {
        position: 'absolute',
        content: '""',
        height: 12,
        width: 12,
        borderStyle: 'solid',
        borderTopWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderLeftWidth: 1,
        borderColor: 'grey-30',
        transform: 'rotate(45deg)',
        transformOrigin: 'center',
        backgroundColor: 'inherit',
        visibility: 'visible'
      }
    },
    variants: {
      top: {
        variant: 'spark.element.popover.arrow.base',
        top: -6,
        before: {
          variant: 'spark.element.popover.arrow.base.before',
          borderTopWidth: 1,
          borderRightWidth: 0,
          borderBottomWidth: 0,
          borderLeftWidth: 1
        }
      },
      bottom: {
        variant: 'spark.element.popover.arrow.base',
        before: {
          variant: 'spark.element.popover.arrow.base.before',
          borderTopWidth: 0,
          borderRightWidth: 1,
          borderBottomWidth: 1,
          borderLeftWidth: 0
        }
      },
      right: {
        variant: 'spark.element.popover.arrow.base',
        right: -6,
        before: {
          variant: 'spark.element.popover.arrow.base.before',
          borderTopWidth: 1,
          borderRightWidth: 1,
          borderBottomWidth: 0,
          borderLeftWidth: 0
        }
      },
      left: {
        variant: 'spark.element.popover.arrow.base',
        left: -6,
        before: {
          variant: 'spark.element.popover.arrow.base.before',
          borderTopWidth: 0,
          borderRightWidth: 0,
          borderBottomWidth: 1,
          borderLeftWidth: 1
        }
      }
    }
  }
};